// src/loaders/plyLoader.js
import { PLYLoader } from 'three/examples/jsm/loaders/PLYLoader.js'
import {
  createMesh,
  centerAndOrientGeometry,
  mergeAndNormalizeGeometry,
  setupColorAttribute,
  setupWeightAttribute,
} from './loaderUtils'

/**
 * Load PLY model from a path or Blob URL
 * @param {string} pathOrBlobUrl - File path or Blob URL
 * @returns {Promise<THREE.Mesh>}
 */
export function loadPLY(pathOrBlobUrl) {
  return new Promise((resolve, reject) => {
    const loader = new PLYLoader()
    loader.load(
      pathOrBlobUrl,
      (geometry) => {
        // Center and orient geometry
        centerAndOrientGeometry(geometry)

        // Merge vertices and compute normals
        // **CRITICAL**: mergeVertices() returns a new indexed geometry object
        // We must capture the return value to ensure proper indexing across all loaders
        geometry = mergeAndNormalizeGeometry(geometry, 1e-4, 'PLY')

        // Setup color attribute
        setupColorAttribute(geometry)

        // Setup weight attribute
        setupWeightAttribute(geometry)

        // Create mesh with standard material
        const mesh = createMesh(geometry, 'PLYMesh')
        resolve(mesh)
      },
      undefined,
      reject
    )
  })
}
